import ArrowIcon from '../../../../assets/icons/drawingTools/arrow'
import ExtendedLineIcon from '../../../../assets/icons/drawingTools/extendedLine'
import RayIcon from '../../../../assets/icons/drawingTools/ray'
import TrendAngleIcon from '../../../../assets/icons/drawingTools/trendAngle'
import TrendLineIcon from '../../../../assets/icons/drawingTools/trendLine'
import InfoLineIcon from '../../../../assets/icons/drawingTools/infoLine'
import { DrawingToolMenuItem } from './drawingToolMenu'
import ParallelChannelIcon from '../../../../assets/icons/drawingTools/parallelChannel'
import FlatTopBottomIcon from '../../../../assets/icons/drawingTools/flatTopBottom'
import DisjointChannelIcon from '../../../../assets/icons/drawingTools/disjointChannel'
import HorizontalLine from '../../../../assets/icons/drawingTools/horizontalLine'
import HorizontalRay from '../../../../assets/icons/drawingTools/horizontalRay'
import CrossLine from '../../../../assets/icons/drawingTools/crossLine'
import VerticalLine from '../../../../assets/icons/drawingTools/verticalLine'

export const lineToolMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'trendLine',
        text: 'Trend Line',
        icon: <TrendLineIcon />,
        drawingType: 'trendLine',
        toolOptions: {
            drawingType: 'trendLine'
        }
    }, {
        drawingToolId: 'trendLine',
        text: 'Arrow',
        icon: <ArrowIcon />,
        drawingType: 'arrow',
        toolOptions: {
            drawingType: 'arrow'
        }
    }, {
        drawingToolId: 'trendLine',
        text: 'Ray',
        icon: <RayIcon />,
        drawingType: 'ray',
        toolOptions: {
            drawingType: 'ray'
        }
    },
    {
        drawingToolId: 'horizontalLine',
        text: 'Horizontal Line',
        icon: <HorizontalLine />,
        drawingType: 'horizontalLine',
        toolOptions: {
            drawingType: 'horizontalLine'
        }
    },
    {
        drawingToolId: 'horizontalRay',
        text: 'Horizontal Ray',
        icon: <HorizontalRay />,
        drawingType: 'horizontalRay',
        toolOptions: {
            drawingType: 'horizontalRay'
        }
    },
    {
        drawingToolId: 'verticalLine',
        text: 'Vertical Line',
        icon: <VerticalLine />,
        drawingType: 'verticalLine',
        toolOptions: {}
    },
    {
        drawingToolId: 'crossLine',
        text: 'Cross Line',
        icon: <CrossLine />,
        drawingType: 'crossLine',
        toolOptions: {}
    },
    {
        drawingToolId: 'trendLine',
        text: 'Extended Line',
        icon: <ExtendedLineIcon />,
        drawingType: 'extendedLine',
        toolOptions: {
            drawingType: 'extendedLine'
        }
    }, {
        drawingToolId: 'trendLine',
        text: 'Trend Angle',
        icon: <TrendAngleIcon />,
        drawingType: 'trendAngle',
        toolOptions: {
            drawingType: 'trendAngle'
        }
    }, {
        drawingToolId: 'trendLine',
        text: 'Info Line',
        drawingType: 'infoLine',
        icon: <InfoLineIcon />,
        toolOptions: {
            drawingType: 'infoLine'
        }
    }, {
        drawingToolId: 'parallelChannel',
        text: 'Parallel Channel',
        icon: <ParallelChannelIcon />,
        drawingType: 'parallelChannel',
        toolOptions: {}
    }, {
        drawingToolId: 'flatTopBottom',
        text: 'Flat Top/Bottom',
        icon: <FlatTopBottomIcon />,
        drawingType: 'flatTopBottom',
        toolOptions: {}
    }, {
        drawingToolId: 'disjointChannel',
        text: 'Disjoint Channel',
        icon: <DisjointChannelIcon />,
        drawingType: 'disjointChannel',
        toolOptions: {}
    }
]